import React from 'react';
import { bool, func, node } from "prop-types"
import { Button, Modal } from 'antd';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Share } from 'arcl';
import { faShare } from '@fortawesome/pro-light-svg-icons';

import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import './style.scss';

function ModalWrapper({ children, isOpen, closeMentorDetailsModal }) {
  return (
    <Modal
      width="100%"
      visible={isOpen}
      closable={false}
      footer={null}
      onCancel={closeMentorDetailsModal}
      wrapClassName="user-details-modal"
      title={
        <div className="arc-d-flex arc-flex-space-between-align">
          <div className="arc-d-flex arc-flex-vertical-align">
            <Button type="link" className="mentorship-modal-left-arrow">
              <FontAwesomeIcon icon={faArrowLeft} onClick={closeMentorDetailsModal} />
            </Button>
            <h6 className="arc-H200 ml16">
              <I18nCustomFormatter id="mentor-modal-label" />
            </h6>
          </div>
          <Share title="Share" url={`${window.location.href}`} disableNativeShare>
            <div className="share-card-icon-text">
              <span id="share-trigger" className="arc-anchor">
                <I18nCustomFormatter id="share-button" />
              </span>
              <FontAwesomeIcon icon={faShare} className="ml12" />
            </div>
          </Share>
        </div>
      }>
      {children}
    </Modal>
  );
}

ModalWrapper.propTypes = {
  children: node.isRequired,
  closeMentorDetailsModal: func.isRequired,
  isOpen: bool.isRequired
}

export default ModalWrapper;
